import { Box, Divider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useUrlParams } from "hooks/useUrlParams";

import OmagunLayout from "../components/OmagunLayout";
import OmagunTitle from "../components/OmagunTitle";

export default function News() {
  const { work } = useUrlParams();
  const { t } = useTranslation([work]);
  const translated = t(`${work}:NewsItems`, { returnObjects: true });
  const items = Array.isArray(translated)
    ? [...translated].sort((a, b) => b.date.localeCompare(a.date))
    : [];

  return (
    <OmagunLayout page="News">
      <Box sx={{ px: 3.5, pb: 8 }}>
        <OmagunTitle>お知らせ</OmagunTitle>
        <Box sx={{ borderTop: "1px solid rgba(255,255,255,.3)" }}>
          {items.length ? items.map((item) => (
            <Box
              key={`${item.date}-${item.title}`}
              component={item.url ? "a" : "div"}
              href={item.url || undefined}
              target={item.url ? "_blank" : undefined}
              rel={item.url ? "noopener noreferrer" : undefined}
              sx={{ display: "block", py: 2.5, color: "#fff", textDecoration: "none", borderBottom: "1px solid rgba(255,255,255,.3)", textAlign: "center" }}
            >
              <Typography sx={{ fontSize: 13, lineHeight: 1.7 }}>{item.title}</Typography>
              <Typography sx={{ mt: 1, color: "#c8c8c8", fontSize: 11 }}>{item.date}</Typography>
            </Box>
          )) : (
            <>
              <Typography sx={{ py: 5, textAlign: "center" }}>現在お知らせはありません</Typography>
              <Divider />
            </>
          )}
        </Box>
      </Box>
    </OmagunLayout>
  );
}
